import {classNames} from "../classNames";
import {ClassProps} from "../types";
import style from "./Spinner.module.css";

export const Spinner = (props: ClassProps) => (
	<div class={classNames(style.spinner, props.class)}>
		<svg viewBox="0 0 100 100">
			<circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="5" strokeMiterlimit="10" />
		</svg>
	</div>
);
